
import axios from "axios";

const APIURL = (window.location.hostname === 'localhost'
    || window.location.hostname === 'nzen') ? 'http://nzen/jo/api-lib/App/SalesRep_App' : 'https://view.optigoapps.com/linkedapp/App/SalesRep_App';

export const CommonAPI = async (body) => {
    try {
        const response = await axios.post(APIURL, body);
        return response?.data;

    } catch (error) {
        console.error('error is..', error);
    }
};
